module.exports = __webpack_public_path__ + "static/img/phonebj7.07be5240.png";